<template>
  <a rel="noopener" target="_blank" :class="$style.link">
    <slot />
    <IconExternalLink :class="$style.link__icon" v-if="!noIcon" />
  </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import IconExternalLink from '@/components/icons/IconExternalLink.vue'

export default defineComponent({
  name: 'ExternalLink',
  components: {
    IconExternalLink,
  },
  props: {
    noIcon: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss" module>
.link {
  display: inline-flex;
  align-items: center;
  color: currentcolor;

  &:hover {
    color: currentcolor;
  }

  &--default {
    color: $color-text-and-object-accent-primary;

    &:hover {
      color: $color-text-and-object-accent-primary;
    }
  }

  &__icon {
    margin-left: 6px;
  }
}
</style>
